import type { OrgMember } from 'src/types';
import { baseFetch } from 'src/utils';

/**
 *
 * @param roles SORTED string of roles separated by _ - example: 'admin_approver'
 * @returns array of OrgMember
 */
export const getUsersByRolesAPI = async (roles: string) => {
  const res = await baseFetch(`/api/org/users/roles/${roles}`, {
    method: 'GET',
  });

  if (!res.ok) {
    throw new Error('Failed to fetch approvers');
  }

  return (await res.json()) as OrgMember[];
};
